<template>
    <div class="article-image">
        <BaseImage
            LoadLazy
            :alt="altText"
            :img-source="content"
            :width="isMobile() ? '350px' : '780px'"
            :height="isMobile() ? '200px' : '440px'"
            quality="90"
        />
    </div>
</template>

<script>
import { mediaQueriesMixin } from '@/mixins';

export default {
    name: 'ArticleImage',
    mixins: [mediaQueriesMixin],
    props: {
        content: {
            text: String,
        },
        altText: {
            text: String,
            default: '',
        },
    },
};
</script>

<style lang="scss" scoped>
@import '@/sass/mixins';
.article-image {
    text-align: center;
    img {
        aspect-ratio: 16 / 9;
        object-fit: cover;
        width: 100%;
        border-radius: 12px;
    }
}
</style>
